var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSatellitesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.792 10.366c.448-.837 1.58-.813 2.27-.121l2.6 2.6.708-.71a1.248 1.248 0 012.12-1.06 1.25 1.25 0 010 1.77 1.246 1.246 0 01-1.06.35l-.707.71 2.6 2.6c.69.69.715 1.822-.122 2.269-.88.47-1.88.716-2.91.7a6.304 6.304 0 01-4.342-1.857 6.302 6.302 0 01-1.855-4.341 5.965 5.965 0 01.698-2.91zM11.453 7.112a4.995 4.995 0 013.442 1.469 4.995 4.995 0 011.468 3.441.751.751 0 01-1.5.024 3.494 3.494 0 00-1.029-2.405 3.494 3.494 0 00-2.404-1.03.75.75 0 01.023-1.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.558 4.174a7.606 7.606 0 015.533 2.21 7.606 7.606 0 012.21 5.534.751.751 0 01-1.5-.028 6.106 6.106 0 00-1.77-4.445 6.106 6.106 0 00-4.446-1.77.75.75 0 01-.027-1.5z",
    fill: "currentColor"
  })));
}
SvgPokerSatellitesFilled.displayName = 'PokerSatellitesFilled';
export default SvgPokerSatellitesFilled;